import type { ComponentRegistry } from './registry';
import { barChartDefinition } from './charts/BarChart';
import { lineChartDefinition } from './charts/LineChart';
import { scatterChartDefinition } from './charts/ScatterChart';
import { pieChartDefinition } from './charts/PieChart';
import { radarChartDefinition } from './charts/RadarChart';

/**
 * The five generic chart types every canvas surface gets. Surfaces with their
 * own widgets spread this into an extended registry:
 * `{ ...builtinChartRegistry, ...myWidgets }`.
 */
export const builtinChartRegistry: ComponentRegistry = {
  [barChartDefinition.type]: barChartDefinition,
  [lineChartDefinition.type]: lineChartDefinition,
  [scatterChartDefinition.type]: scatterChartDefinition,
  [pieChartDefinition.type]: pieChartDefinition,
  [radarChartDefinition.type]: radarChartDefinition,
};
